import { render, staticRenderFns } from "./PageRegistration.vue?vue&type=template&id=76ff5a49&scoped=true"
import script from "./PageRegistration.vue?vue&type=script&lang=ts"
export * from "./PageRegistration.vue?vue&type=script&lang=ts"
import style0 from "./PageRegistration.vue?vue&type=style&index=0&id=76ff5a49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ff5a49",
  null
  
)

export default component.exports